<template>
  <tbody :id="id">
    <product v-for="(product, index) in products"
      :product="product"
      :position-number="index + 1"
      :index="index"
      :key="product.id"
      @remove="removeProduct"
      @change="changeProduct"
    ></product>
  </tbody>
</template>

<script>
import Product from 'components/Products/InvoiceRow'

export default {
  props: ['products', 'id'],
  methods: {
    removeProduct (index) {
      this.$emit('remove', index)
    },
    changeProduct (index, key, value) {
      const product = this.products[index]
      product[key] = value
      this.$emit('change', index, product)
    }
  },
  components: {
    Product
  }
}
</script>

<style lang="scss" scoped>
@import "~assets/common.scss";
</style>



/** WEBPACK FOOTER **
 ** InvoiceList.vue?7957e54a
 **/